import React from 'react';
import { LegalPage } from './LegalLayout';

const Privacy = () => <LegalPage pageKey="confidentialite" />;

export default Privacy;
